// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function suspension_duration_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tag = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tag"), null));
  if (tag.TAG === /* Ok */0) {
    var hours = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "hours"), null));
    if (hours.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                tag: tag._0,
                hours: hours._0
              }
            };
    }
    var e = hours._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".hours" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = tag._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tag" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function suspension_reason_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var suspension_durations = Decco.listFromJson(suspension_duration_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "suspension_durations"), null));
      if (suspension_durations.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  description: description._0,
                  suspension_durations: suspension_durations._0
                }
              };
      }
      var e = suspension_durations._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".suspension_durations" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.listFromJson(suspension_reason_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  suspension_duration_decode ,
  suspension_reason_decode ,
  t_decode ,
  
}
/* No side effect */
